export default ($) => {
    let $newsEvents = $('.js-newsEvents');

    $newsEvents.each(function () {
        let _this = $(this);
        let _overlay = _this.find('.js-overlay');

        calcSize(_this, _overlay);

        $(window).resize(function () {
            calcSize(_this, _overlay);
        });
    });

    function calcSize(item, overlay) {
        let width = item.innerWidth();
        let height = item.innerHeight();

        overlay.css({
            'width': `${height}`,
            'height': `${width / 2}`
        });
    }
};